import { Controller } from '@hotwired/stimulus'

// Swaps the menu link copy row to the menu picked: all menus, or one menu's own page.
export default class extends Controller {
  static targets = ['pick', 'copy', 'field']

  update() {
    const url = this.pickTarget.value
    this.copyTarget.dataset.copyToClipboardValue = url
    this.fieldTarget.value = url
  }
}
